import React from 'react';

import { Title } from '@mantine/core';
import { ReactComponent as KiloLogo } from 'assets/svg/long_kilo_blue_white.svg';

interface ISimpleHeader {
  title: string;
}

const SimpleHeader = ({ title }: ISimpleHeader): JSX.Element => {
  return (
    <div className='header'>
      <Title order={3} color='gray.8' align='center'>
        {title}
      </Title>
      <KiloLogo height='100%' width={50} />
    </div>
  );
};

export default SimpleHeader;
